// extracted by mini-css-extract-plugin
export default {"container":"item_container__Yl9S5","date":"item_date__c4UPQ","name":"item_name__-jxNs","organization":"item_organization__zba-g"};